import { createStore } from 'vuex'
import log from './modules/Log'
import select from './modules/Select'
const axios = require('axios')

export default createStore({
  modules: {
    log,
    select // 筛选状态
    // 其它模块
  }
})
